import {
  type ProductizedServicePriceInterval,
  type ProductizedServicePriceType,
} from '#app/__generated__/api.js';
import { type ExcludeRelayFutureAddedValue } from '#app/types/utils.js';

export const INTERVAL_LABELS: Record<
  ExcludeRelayFutureAddedValue<ProductizedServicePriceInterval>,
  string
> = Object.freeze({
  DAY: 'day',
  HOUR: 'hour',
  MONTH: 'month',
  WEEK: 'week',
});

export const DEFAULT_PRICE_INTERVAL = 'HOUR' as const;

export const DEFAULT_PRICE_TYPE = 'FIXED_PRICE' as const;

export const PRICE_TYPE_LABELS: Record<
  ExcludeRelayFutureAddedValue<ProductizedServicePriceType>,
  string
> = Object.freeze({
  CONTACT_FOR_PRICING: 'Contact For Pricing',
  FIXED_PRICE: 'Fixed Price',
  RATE: 'Rate',
});

/**
 * Represents the current step of the creation flow the user is on.
 * This will visually keep the user focused on completing the current step via `<ServiceStep />`.
 *
 * New flow: `'details'` -> `'deliverables'` -> `'content'`.
 *
 * Editing flow: `'complete'`.
 */
export enum PRODUCTIZED_SERVICE_STEP {
  Complete = 4,
  Content = 3,
  Deliverables = 2,
  Details = 1,
}
